import * as AdminControlUserMgmtConstants from "./AdminControlUserMgmtConstants";
import {
  STATUS_FAILURE,
  STATUS_SUCCESS,
  STATUS_PENDING,
} from "Common/constants/commonConstants";
// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require("object.assign");

/**
 * initial state which is managed by AdminControlUserMgmtReducer
 */
const initialState = {
  fetchStatus:STATUS_SUCCESS,
  addStatus:STATUS_SUCCESS,
  deleteStatus:STATUS_SUCCESS,
  userList:[],
  filteredUserList:[],
  isUserDeleteConfirmPopup:false,
  isOpenMessagePopup:false,
  modalMessage:""
};

/**'
 * redux reducer method which takes the current state and the action as input parameters and returns with the new state
 */
export default function AdminControlUserMgmtReducer(state = initialState, action) {
  switch (action.type) {
    case AdminControlUserMgmtConstants.FETCH_USER_LIST_REQUEST:
          return assign({}, state, {
              fetchStatus:STATUS_PENDING,
              userList:[]
            });
    case AdminControlUserMgmtConstants.FETCH_USER_LIST_SUCCESS:
          return assign({}, state, {
              fetchStatus:STATUS_SUCCESS,
              userList:action.payload,
              filteredUserList:action.payload
            });
    case AdminControlUserMgmtConstants.FETCH_USER_LIST_ERROR:
          return assign({}, state, {
              fetchStatus:STATUS_FAILURE,
              userList:[]
            });
    case AdminControlUserMgmtConstants.FETCH_USER_LIST_SEARCH:
          return assign({}, state, {
              fetchStatus:STATUS_SUCCESS,
              filteredUserList: action.newState.filteredUserList
            });
    case AdminControlUserMgmtConstants.ADD_USER_REQUEST:
          return assign({}, state, {
              addStatus:STATUS_PENDING,
              isOpenMessagePopup:false,
          });
    case AdminControlUserMgmtConstants.ADD_USER_SUCCESS:
          return assign({}, state, {
              addStatus:STATUS_SUCCESS,
              isOpenMessagePopup:true,
              modalMessage:action.payload
          });
    case AdminControlUserMgmtConstants.ADD_USER_ERROR:
          return assign({}, state, {
              addStatus:STATUS_FAILURE,
              isOpenMessagePopup:true,
              modalMessage:action.payload
          });
    case AdminControlUserMgmtConstants.DELETE_USER_REQUEST:
          return assign({}, state, {
            deleteStatus:STATUS_PENDING
          });
    case AdminControlUserMgmtConstants.DELETE_USER_SUCCESS:
          return assign({}, state, {
            deleteStatus:STATUS_SUCCESS,
            isOpenMessagePopup:true,
            modalMessage:action.payload,
          });
    case AdminControlUserMgmtConstants.DELETE_USER_ERROR:
          return assign({}, state, {
            deleteStatus:STATUS_FAILURE,
            isOpenMessagePopup:true,
            modalMessage:action.payload,
          });
    case AdminControlUserMgmtConstants.CLOSE_SUCCESS_USER_POPUP:
          return assign({}, state, {
            isOpenMessagePopup:action.newState.isOpenMessagePopup,
            modalMessage:"",
            addStatus:STATUS_SUCCESS,
            deleteStatus:STATUS_SUCCESS
          });
    case AdminControlUserMgmtConstants.DELETE_USER_CONFIRMATION_POPUP:
          return assign({}, state, {
            isUserDeleteConfirmPopup:  action.newState.isUserDeleteConfirmPopup,
            modalMessage:""
          });
    default:
      return state;
  }
}
